export default __webpack_public_path__ + "static/media/Reader's Armbands of the Burning Disc.b0ce92fd.jpg";